<template>
  <div>
    <v-card>
      <v-card-text>
        <v-tabs>
          <v-tab ripple @click="refreshPosting">
            Posting
          </v-tab>
          <v-tab ripple @click="refreshPosted">
            Posted Today
          </v-tab>
          <v-tab-item>
          <v-layout row wrap>
            <v-flex xs12>
              <form>
                <v-expansion-panel expand :value="[true]" class="mt-3">
                  <v-expansion-panel-content>
                    <div slot="header">
                      <v-icon>mdi-filter-variant</v-icon> Filters
                    </div>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-int-mask="{intScale: 11}" v-model="filters.clmRefNo" :label="filtersLabel.clmRefNo" type="tel" :error-messages="errors.collect('clmRefNo')" data-vv-name="clmRefNo" :data-vv-as="filtersLabel.clmRefNo" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-int-mask="{intScale: 11}" v-model="filters.clmSubNo" :label="filtersLabel.clmSubNo" type="tel" :error-messages="errors.collect('clmSubNo')" data-vv-name="clmSubNo" :data-vv-as="filtersLabel.clmSubNo" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.polNo" :label="filtersLabel.polNo" :error-messages="errors.collect('polNo')" data-vv-name="polNo" :data-vv-as="filtersLabel.polNo" v-validate="'entry|max:16'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="params.intermediaries" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="params.products" v-model="filters.product" :label="filtersLabel.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="filtersLabel.product" :error-messages="errors.collect('product')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.appName" :label="filtersLabel.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="filtersLabel.appName" v-validate="'name|max:60'"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <transition name="slide-x-transition" mode="out-in">
                            <v-layout row wrap v-if="showDetailFilters">
                              <v-flex xl3 lg4 xs6>
                                <v-text-field v-model="filters.usrRefId" :label="filtersLabel.usrRefId" :error-messages="errors.collect('usrRefId')" data-vv-name="usrRefId" :data-vv-as="filtersLabel.usrRefId" v-validate="'entry|max:60'"></v-text-field>
                              </v-flex>
                              <v-flex xl3 lg4 xs6></v-flex>
                              <v-flex xl3 lg4 xs6></v-flex>
                              <v-flex xl3 lg4 xs6></v-flex>
                              <v-flex xl3 lg4 xs6>
                                <cal-picker v-model="filters.lossFrom" :label="filtersLabel.lossFrom" :data-vv-as="filtersLabel.lossFrom" data-vv-name="lossFrom" :error-messages="errors.collect('lossFrom')"></cal-picker>
                              </v-flex>
                              <v-flex xl3 lg4 xs6>
                                <cal-picker v-model="filters.lossTo" :label="filtersLabel.lossTo" :data-vv-as="filtersLabel.lossTo" data-vv-name="lossTo" :error-messages="errors.collect('lossTo')"></cal-picker>
                              </v-flex>
                              <v-flex xl3 lg4 xs6>
                                <cal-picker v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                              </v-flex>
                              <v-flex xl3 lg4 xs6>
                                <cal-picker v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                              </v-flex>
                            </v-layout>
                          </transition>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </form>
            </v-flex>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
            <v-flex xs12>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                  <v-btn color="secondary" class="white--text" slot="activator">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                  <v-card>
                    <v-card-text>
                      <template v-if="columns.length > 0">
                        <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                      </template>
                      <template v-else>
                        No column found
                      </template>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="mt-2">
              <v-data-table :headers="listHeaders" :items="items" item-key="clmRefNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText" v-model="selected" select-all>
                <template slot="items" slot-scope="props">
                  <td width="50px">
                    <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
                  </td>
                  <td v-for="column in selectedColumns" :key="column">
                    {{props.item[column]}}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <div class="pt-2">
              <v-btn color="primary" @click="doPromptPost" :loading="loading">
                Post Selected
                <v-icon right>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            <confirm v-model="promptPost" @ok="doPost">
              Are you sure you want to post selected record(s)?
            </confirm>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <package-claim-posted v-model="loadPosted"></package-claim-posted>
        </v-tab-item>
      </v-tabs>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import clone from 'clone'
import { postingMixin } from '../postingMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import toDate from 'date-fns/toDate'
import { removeTime, setEndTime, formatDisplayDateTime2 } from '@/utils/date'
import PackageClaimPosted from './PackageClaimPosted'

export default {
  data() {
    return {
      columns: [
        { text: 'Claim Reference No.', align: 'left', value: 'clmRefNo' },
        { text: 'Claim Submission No.', align: 'left', value: 'clmSubNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Intermediary', value: 'intermediary' },
        { text: 'Product', value: 'product' },
        { text: 'Plan', value: 'plan' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Policy Holder', value: 'appName' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'Loss Date', value: 'lossDate' },
        { text: 'User Ref Id', value: 'usrRefId' }
      ],
      selectedColumns: ['clmRefNo', 'clmSubNo', 'polNo', 'proposalNo', 'appName', 'busCls', 'lossDate', 'createdDate'],
      filtersLabel: {
        clmRefNo: 'Claim Reference No.',
        clmSubNo: 'Claim Submission No.',
        polNo: 'Policy No.',
        proposalNo: 'Proposal No.',
        intermediary: 'Intermediary',
        product: 'Product',
        plan: 'Plan',
        appName: 'Policy Holder',
        lossFrom: 'Loss Date From',
        lossTo: 'Loss Date To',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To',
        usrRefId: 'User Ref Id'
      },
      filters: {
        proposalNo: null,
        clmRefNo: null,
        clmSubNo: null,
        polNo: null,
        intermediary: null,
        product: null,
        plan: null,
        appName: null,
        lossFrom: null,
        lossTo: null,
        entryFrom: null,
        entryTo: null,
        usrRefId: null
      },
      params: {
        intermediaries: [],
        products: [],
        plans: []
      },
      showDetailFilters: false,
      promptPost: false,
      loadPosted: false
    }
  },
  methods: {
    refreshPosting() {
      this.fetchData(false)
      this.loadPosted = false
    },
    refreshPosted() {
      this.loadPosted = true
    },
    async fetchData(options) {
      if (this.apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage,
            options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.lossFrom) {
            massageFilters.lossFrom = formatDisplayDateTime2(removeTime(massageFilters.lossFrom))
          }
          if (massageFilters.lossTo) {
            massageFilters.lossTo = formatDisplayDateTime2(setEndTime(massageFilters.lossTo))
          }
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))

          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((claim) => {
                const convertClaim = {
                  clmRefNo: claim.clmRefNo,
                  clmSubNo: claim.clmSubNo,
                  polNo: claim.polNo,
                  proposalNo: claim.proposalNo,
                  product: claim.productName,
                  busCls: claim.busClsName,
                  intermediary: claim.intermediaryName,
                  appName: claim.appName,
                  lossDate: this.formatDate(toDate(claim.lossDate)),
                  createdDate: this.formatDate(toDate(claim.createdDate)),
                  usrRefId: claim.usrRefId
                }
                this.items.push(convertClaim)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$set(this.params, 'intermediaries', result.data.intermediaries)
              this.$set(this.params, 'products', result.data.products)
              this.$set(this.params, 'plans', result.data.plans)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doPromptPost() {
      if (this.selected.length > 0) {
        this.promptPost = true
      } else {
        this.$snotify.warning('Please select record(s) to be posted.')
      }
    },
    async doPost() {
      const apiURI = this.postingState.menu.postSelected
      if (apiURI) {
        this.loading = true
        let postForm = []
        this.selected.map(select => {
          postForm.push(select.clmRefNo)
        })
        try {
          const result = await this.$http.post(apiURI, postForm)
          this.notify(result.data)

          // Reinit
          this.fetchData(false)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.loading = false
        }
        this.selected = []
      }
    },
    doClearFilters() {
      this.filters.clmRefNo = null
      this.filters.clmSubNo = null
      this.filters.polNo = null
      this.filters.proposalNo = null
      this.filters.intermediary = null
      this.filters.product = null
      this.filters.appName = null
      this.filters.lossFrom = null
      this.filters.lossTo = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.filters.usrRefId = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  created() {
    this.apiUrl = this.postingState.menu.pkg
  },
  mixins: [
    postingMixin
  ],
  components: {
    PackageClaimPosted
  }
}
</script>

<style lang="scss">
</style>
